<header>
  <nav class="navbar navbar-expand-lg fixed-top">
    <div class="container-fluid">
      <div class="inner">
        <a class="navbar-brand logo" routerLink="/about" routerLinkActive="active" translate>JTS</a>
        <div id="navbar-menu" class="collapse navbar-collapse">
          <div class="navbar-nav navbar-part1 me-auto mb-lg-0">
            <a class="nav-item nav-link" routerLink="/about" routerLinkActive="active">
              <span translate>About Us</span>
            </a>
            <a class="nav-item nav-link" routerLink="/projects/overseas" routerLinkActive="active">
              <span translate>Our Projects</span>
            </a>
            <a class="nav-item nav-link" routerLink="/donate" routerLinkActive="active">
              <span translate>How To Donate</span>
            </a>
          </div>
          <div class="navbar-nav">
            <a class="nav-item nav-link navbar-part2" href="http://www.jts.or.kr">
              <span translate>KOREAN</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>
